import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import LandingPage from '@/pages/LandingPage/LandingPage';
import LoginPage from '@/pages/LoginPage/Login';

import { AppSidebar } from '@/components/app-sidebar';
import { PageActions } from '@/components/page-actions';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';

import { ProtectedComponent } from './components/ProtectedComponent';
import { ResetPassword } from './pages/ResetPassword/reset-password';

import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { getPageTitle, ROUTES } from '@/routes/routes';

const Title = () => {
  const { pathname } = useLocation();
  return <h1 className="text-lg font-semibold">{getPageTitle(pathname)}</h1>;
};

const HeaderLeft = () => {
  return (
    <>
      <SidebarTrigger />
      <Title />
    </>
  );
};

const MainLayout = () => {
  return (
    <TooltipProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="flex flex-col h-screen overflow-hidden">
          <header className="sticky top-0 z-50 bg-background flex h-14 shrink-0 items-center gap-2 border-b p-4">
            <HeaderLeft />
            <PageActions />
          </header>
          <div className="flex flex-1 overflow-y-auto">
            {/* Main Content */}
            <div className="flex flex-col w-full">
              <div className="flex-1 p-4">
                <section className="w-full max-w-none h-full">
                  <Routes>
                    {ROUTES.map(({ path, element, requiredPermissions }) => {
                      const Component = element;
                      return (
                        <Route
                          key={path}
                          path={path}
                          element={
                            <ProtectedComponent requiredPermissions={requiredPermissions}>
                              <ProtectedRoute>
                                <Component />
                              </ProtectedRoute>
                            </ProtectedComponent>
                          }
                        />
                      );
                    })}
                  </Routes>
                </section>
              </div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
};

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
